import { useRef } from "react";
import { useApp } from "@/App";
import { LANDING_LANGS, useLandingTranslator } from "@/components/landing/useLandingTranslator";

// Translates the German UI text inside its children into the portal language (names: add translate="no").
export const AutoTranslate = ({ children, className, ...rest }) => {
  const { lang } = useApp();
  const ref = useRef(null);
  useLandingTranslator(LANDING_LANGS.some((l) => l.code === lang) ? lang : "de", ref);
  return <div ref={ref} className={className} {...rest}>{children}</div>;
};
